import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import Layout from "src/components/layout/Layout";
import TimesheetList from "src/components/lists/TimesheetList";
import useTask from "src/hooks/api/tasks/useTask";

function HoursDetailCompanyView({ t }: Translation) {
	const location = useLocation();
	const { id } = useParams() as any;
	const { task, actions, status } = useTask();

	useEffect(() => {
		if (!task?.id || task?.hid !== id) {
			actions.get(true, "variant=table&is_hourlist=1&include[]=parent");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	return (
		<Layout title={t("title")} loading={status !== "idle"} backUrl="/hours">
			{task?.id && status === "idle" && <TimesheetList {...{ task }} />}
		</Layout>
	);
}

HoursDetailCompanyView.locale = {
	nl: {
		title: "Uren controle",
	},
	en: {
		title: "Hour registration",
	},
};

export default withTranslation(HoursDetailCompanyView);
